/* eslint-disable no-eval */
import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, message, notification } from 'antd';
import './gantt.css';
import { historicalActivityProgressService } from '../../../services/historicalactivityprogress.service';
import {
  activityService,
  sectorService,
  activityRelationService,
  sectorBaselinePointService
} from '../../../services';
import {
  convertGanttTaskToActivity,
  convertLinkToActivityRelation,
  calculatePonderators,
  createBaseCalendarFromCalendar,
  getBodyForNewBaseline,
  setCustomHourFn,
  updateSubmittalsHelper,
  getAccumulatedGanttDuration,
  baselineOptions
} from './gantt.helper';
import { getDrawerSelector } from '../../../redux/slices/hoveringStackSlice';
import { useSelector, useDispatch, connect } from 'react-redux';
import * as ganttActions from '../../../redux/slices/ganttSlice';
import {
  getSelectedActivitiesSelector,
  getGanttLoadingSelector,
  getGanttCalendarsSelector
} from '../../../redux/slices/ganttSlice';
import GanttFilterHeader from '../../../components/GanttFilterHeader';
import { sectorBaselineVersionService } from '../../../services/index';
import cloneDeep from 'lodash/cloneDeep';
import ModalAddSubContract from '../../../components/Settings/ModalAddSubContract';
import ModalAddTags from '../../../components/Settings/ModalAddTags';
import ConstraintValidationModal from '../../../components/constraintValidationModal';
import moment from 'moment';
import { dynamicSort } from '../../../utils';
import masterplanPermissions from '../../../hooks/useMasterplanPermissions';

import { check_progress } from '../../../assets/js/gantt_lifecycle/editing-flow';
import { withTranslation } from 'react-i18next';
import { trakerServiceAppCues } from '../../../utils/appcues-util';
import colors from '../../../stylesheets/variables.scss';
import modalStyles from './modals.module.scss';
import BaselineModal from '../../../components/BaselineModal';
import { ScheduleModal } from '../../../components/ScheduleModal/ScheduleModal';
import ActivityModification from '../../../components/ActivityModification';
import { WarningIcon } from '../../../icons';

import { notifyMessage } from '../../../utils/lookahead-common';
import { trackingEvent } from '../../../analytics/index';
import { AMPLITUDE_SERVICE } from '../../../analytics/constants';
import {
  getBasicAmplitudEventProperties,
  getSectorCompanyAndProject
} from '../../../analytics/utils';
import * as Sentry from '@sentry/react';
import { addBreadcrumbUtil, log } from '../../../monitor/monitor';
import ModalSystem from '../../../components/DesignSystem/ModalSystem';
import { activeSectorFlag } from '../../../utils/activeSectorFlag';
import { updateDefaultView } from '../../../services/views/viewSync';

import { checkForChanges } from '../../../hooks/useUnsavedElementsAlerter';
import ModalRemoveTaskLookahead from '../../../components/ModalRemoveTaskLookahead/ModalRemoveTaskLookahead';
import ModalMessage from '../../../components/ExportablePDFMessage/ModalMessage';

import {
  totangoEventTracking,
  totangoSetAccountAttributes
} from '../../../analytics/implements/totango';
import { getSignedUser } from '../../../utils/userUtils';

import { validateActivityAttributes } from './validateActivityBeforeSave/helpers/validateActivity.helper';
import { activityAttributes } from '../../../constants/validateActivity.constants';

import { TimerManagerSingleton } from '../../../utils/timerManager';
import { useSchedule } from '../../schedule/context/ScheduleContext';
import {
  hideSubcontractModal,
  hideTagsModal,
  getIsModalSubcontractVisible,
  getIsModalTagsVisible
} from '../../../redux/slices/uiSlice';
import { ActivitiesStorage } from '../../../assets/js/gantt_storage/activities';
import { LinksStorage } from '../../../assets/js/gantt_storage/links';

// Custom hooks
import { useScheduleUpdates } from '../../../hooks/useScheduleUpdates';
import { useBaselines } from '../../../hooks/useBaselines';
import { useSubcontracts } from '../../../hooks/useSubcontracts';
import { useTags } from '../../../hooks/useTags';
import { useResponsables } from '../../../hooks/useResponsables';

import { updateExpectedProgressWithBaseline } from '../../../assets/js/events/utils/updateExpectedGlobal';

const showModalWhenDeleteActivies = false; // just in case that we need to back to modal

message.config({
  maxCount: 1
});


const LEGACY_GANTT_URL = '/ganttchart';
const NEW_GANTT_URL_PATTERN = /^\/\d+\/project\/\d+\/schedule\/\d+\/?$/;

// Helper functions to check URL patterns
const isLegacyGanttUrl = (pathname) => pathname.includes(LEGACY_GANTT_URL);
const isNewGanttUrl = (pathname) => NEW_GANTT_URL_PATTERN.test(pathname);

function GanttChartView(props) {
  const {
    t,
    modalCircular,
    modalDelMass,
    modalDupMass,
    modalDupConfirmMass,
    modalDupMassAddActivities,
    selectedActivities,
    callbackModalDupConfirmMass,
    drawer,
    isGanttLoading
  } = props;
  const timerManager = useRef(TimerManagerSingleton.getInstance()).current;
  const [isFirstView, setIsFirstView] = useState(true);
  const { ganttId, scheduleGanttFullyLoaded, ganttInstance, isANewProject } =
    useSchedule();

  // Use custom hook for schedule updates
  const { allScheduleUpdates, fetchScheduleUpdates } = useScheduleUpdates();

  // Use custom hooks for fetching data but get data from Redux slices
  const { fetchSubcontractsByProject } = useSubcontracts();
  const { fetchTagsByProject } = useTags('schedule');
  const { fetchResponsablesBySector } = useResponsables();

  // Use custom hook for baselines
  const {
    allBaselinePoints,
    allBaselines: baselinesFromHook,
    loadActivityPoints,
    loadBaselineData,
    processBaselinePoints,
    loadActivityVersions,
    loading: baselinesLoading,
    setAllBaselines
  } = useBaselines();
  const [activityModificationSelected, setActivityModificationSelected] =
    useState(false);
  const gantt = window.to_use_react_gantt;
  const [modalMetadata, setModalMetadata] = useState({
    visible: false,
    onOkPayload: () => {},
    onCancelPayload: () => {},
    title: 'Modal',
    content: <div>Modal</div>,
    cancelText: 'Cancel',
    okText: 'Ok'
  });
  const [modalMetadataDelete, setModalMetadataDelete] = useState({
    visible: false,
    onOkPayload: () => {},
    onCancelPayload: () => {},
    title: 'Modal',
    isRunning: false,
    content: <div>Modal</div>,
    cancelText: 'Cancel',
    okText: 'Ok'
  });
  const tasksToDelete = useRef([]);
  const linksToDelete = useRef([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [deletedUnsavedActivities, setDeletedUnsavedActivities] = useState([]);
  const [deletedUnsavedLinks, setDeletedUnsavedLinks] = useState([]);

  const projectState = useSelector((state) => state.projectState);
  const stateCompany = useSelector((state) => state.companyState);
  const sectorObject = projectState.allSectors.find(
    (e) => e.id === projectState.sectorSelected
  );
  const ganttState = useSelector((state) => state.ganttState);

  const dispatch = useDispatch();

  const [saveBaselineModal, setSaveBaselineModal] = useState({
    visible: false,
    title: '',
    name: '',
    description: '',
    toSaveOption: 1
  });
  const [saveBaselineModalAuto, setSaveBaselineModalAuto] = useState({
    visible: false,
    title: '',
    name: '',
    description: '',
    toSaveOption: 4
  });
  const [allBaselinesModal, setAllBaselinesModal] = useState({
    visible: false,
    title: ''
  });

  const [allScheduleUpdatesModal, setAllScheduleUpdatesModal] = useState({
    visible: false,
    title: ''
  });
  const [saveScheduleUpdatesModal, setSaveScheduleUpdatesModal] = useState({
    visible: false,
    update_name: '',
    comment: '',
    toSaveOption: 1
  });

  const visibleFormSubcontract = useSelector(getIsModalSubcontractVisible);
  const visibleFormTags = useSelector(getIsModalTagsVisible);

  const [isProcessing, setIsProcessing] = useState(false);

  const [zoomLevel, setZoomLevel] = useState(null);
  /** set hour min y max */
  const [customHour, setCustomHour] = useState({ startHour: '', endHour: '' });
  const [saveProcessActive, setSaveProcessActive] = useState(false);
  const [showBackUpModal, setShowBackUpModal] = useState(false);
  const { currentSector, currentProject, currentCompany } =
    getSectorCompanyAndProject();
  const [isShowModalPDF, setIsShowModalPDF] = useState(false);

  const [isShowModalRemoveTaskLookahead, setIsShowModalRemoveTaskLookahead] =
    useState(false);
  const [dataModalRemoveTaskLookahead, setDataModalRemoveTaskLookahead] =
    useState({
      t: null,
      task: null,
      parent: null,
      parentProplannerId: null
    });

  const ganttCalendars = useSelector(getGanttCalendarsSelector);
  const calendars = useSelector(getGanttCalendarsSelector);

  /** use effect to set hours according shifts */
  useEffect(() => {
    if (!calendars) return;
    if (Object.keys(calendars).length !== 0) {
      const calendarDefault =
        calendars && calendars.find((el) => el.is_default);
      if (calendarDefault) {
        const shifts = calendarDefault.shifts;
        const shiftOrdered = shifts.sort(dynamicSort('correlative_id', true));

        /** get shifts */
        const firstShift = shiftOrdered[0].shift_string;
        const lastShift = shiftOrdered[shiftOrdered.length - 1].shift_string;

        /** calculate ini */
        const shiftArr = firstShift.split('-');
        const firstHourArr = shiftArr[0].split(',');

        /** calculate end */
        const shiftArrEnd = lastShift.split('-');
        const lastHourArr = shiftArrEnd[1].split(',');

        /** calculate min hour of the last shift */
        let lastHourMin = 99;
        firstHourArr.map((el) => {
          if (parseInt(el) < parseInt(lastHourMin)) {
            lastHourMin = el;
          }
        });

        /** calculate max hour of the last shift */
        let lastHourMax = 0;
        lastHourArr.map((el) => {
          if (parseInt(el) > parseInt(lastHourMax)) {
            lastHourMax = el;
          }
        });

        if (lastHourMin && lastHourMax) {
          setCustomHour({
            ...customHour,
            startHour: lastHourMin,
            endHour: lastHourMax
          });
        }
      }
    }
    setCustomHourFn(calendars, customHour, setCustomHour);
  }, [calendars]);

  useEffect(() => {
    const showLoader = saveProcessActive || isProcessing;
    if (showLoader) {
      window.loader.show();
    } else {
      window.loader.hide();
    }
  }, [saveProcessActive, isProcessing]);

  // Efecto para cargar los datos iniciales del sector
  useEffect(() => {
    if (scheduleGanttFullyLoaded && ganttInstance) {
      if (masterplanPermissions()?.gantt === 'V') {
        window.to_use_react_gantt.config.readonly = true;
      }
      const loadInitialData = async () => {
        try {
          fetchScheduleUpdates(projectState.sectorSelected);

          fetchSubcontractsByProject();
          fetchTagsByProject(projectState.projectSelected);
          fetchResponsablesBySector(projectState.sectorSelected);
          updateFlagSector();

          const ganttTasksCount = ganttInstance.getTaskByTime().length;
          const storedActivitiesCount =
            ActivitiesStorage.initialActivities.size;

          if (storedActivitiesCount === 0 && ganttTasksCount > 0) {
            ActivitiesStorage.init(ganttInstance, true);
          } else if (storedActivitiesCount !== ganttTasksCount) {
            ActivitiesStorage.init(ganttInstance, true);
          }

          const loadBaselines = async () => {
            try {
              await loadActivityPoints(projectState.sectorSelected);
              await loadActivityVersions(projectState.sectorSelected);
            } catch (error) {
              Sentry.captureException(error);
            }
          };

          loadBaselines();
        } catch (error) {
          Sentry.captureException(error);
        }
      };

      loadInitialData();
    }
    if (isANewProject) {
      message.info(t('default_activities_gantt'), 5);
      saveHandler();
    }
  }, [scheduleGanttFullyLoaded]);

  // Process baseline points when they are available and update gantt data
  useEffect(() => {
    const processBaselinePoints = async () => {
      if (allBaselinePoints.length > 0) {
        ganttInstance.getTaskByTime().map((data) => {
          const baselinePoints = allBaselinePoints.filter(
            ({ activityId }) => activityId === data.proplannerId
          );
          data.baseline_points = baselinePoints;
        });

        updateExpectedProgressWithBaseline({
          immediate: true,
          avoidRender: true
        });

        if (sectorObject.update_ponderators_masterplan) {
          message.info(t('change_criteria_alert'), 3);
          await goCalculatePonderators(true);
          updateFlagSector(gantt);
        }
        // requested goSaveHangle because of work hours change
        if (sectorObject.update_activities_work_hours) {
          requestGoSaveHandler();
        }
      }
    };

    processBaselinePoints();
  }, [allBaselinePoints]);

  /** This effect handles events for keep filtering working fine, it first group, then order and at last filter */

  useEffect(() => {
    dispatch(ganttActions.notifyLookaheadUpdateGroup());

    const orderCallback = () => {
      dispatch(ganttActions.notifyLookaheadUpdateOrder());
    };
    timerManager.registerAutoTimeout(orderCallback, 50, 'lookaheadOrder');

    const filterCallback = () => {
      dispatch(ganttActions.notifyLookaheadUpdateFilter());
    };
    timerManager.registerAutoTimeout(filterCallback, 100, 'lookaheadFilter');
  }, [ganttState.notifyChange]);

  useEffect(() => {
    const fetchData = async () => {
      if (allBaselinePoints.length > 0) {
        ganttInstance.getTaskByTime().map((data) => {
          const baselinePoints = allBaselinePoints.filter(
            ({ activityId }) => activityId === data.proplannerId
          );
          data.baseline_points = baselinePoints;
        });

        updateExpectedProgressWithBaseline({
          immediate: true,
          avoidRender: true
        });

        if (sectorObject.update_ponderators_masterplan) {
          message.info(t('change_criteria_alert'), 3);
          await goCalculatePonderators(true);
          updateFlagSector(gantt);
        }
        // requested goSaveHangle because of work hours change
        if (sectorObject.update_activities_work_hours) {
          requestGoSaveHandler();
        }
      }
    };

    fetchData();
  }, [allBaselinePoints]);

  const updateFlagSector = async () => {
    if (sectorObject.update_ponderators_masterplan) {
      await sectorService.updatePonderatorMaster(
        projectState.sectorSelected,
        false
      );
      await sectorService.updateprimaveradurationmaster(
        projectState.sectorSelected,
        false
      );
      ganttInstance.clearStacks = true;
      await sectorService.invalidateCache(projectState.sectorSelected);
      saveHandler();
      sectorObject.update_ponderators_masterplan = false;
    }
    if (sectorObject.update_save_handle_for_calendar_update) {
      await sectorService.updatecalendarsavemaster(
        projectState.sectorSelected,
        false
      );
    }

    const isSomeAutoAssignedCalendar =
      ganttInstance &&
      ganttInstance.getTaskByTime().some((el) => el.assignedDefaultCalendar);
    if (isSomeAutoAssignedCalendar) {
      const elementWithAssignedDefaultCalendar = ganttInstance
        .getTaskByTime()
        .filter((el) => el.assignedDefaultCalendar);
      elementWithAssignedDefaultCalendar.forEach((el) => {
        el.assignedDefaultCalendar = false;
      });

      ganttInstance.clearStacks = true;
      saveHandler();
    }
  };

  /** This effect allow heavy gantt processes to finish without freezing the web browser */
  useEffect(() => {
    if (!ganttInstance) {
      return;
    }
    updateFlagSector();
  }, [isProcessing]);

  /** This effect just updates appcues instance */
  useEffect(() => {
    window.Appcues.page();
  });

  /** Tags are now managed by the useTags hook in ModalAddTags component */

  /** Subcontracts are now managed by the useSubcontracts hook in ModalAddSubContract component */

  useEffect(() => {
    window.stackActivitiesMotherSave = new Set();

    return () => (window.stackActivitiesMotherSave = new Set());
  }, []);

  useEffect(() => {
    /* eslint-disable-next-line no-console */
    // Solo agregar el listener cuando el Gantt esté completamente listo
    if (scheduleGanttFullyLoaded) {
      window.addEventListener('beforeunload', unsavedChangesListener);
    }
  }, [scheduleGanttFullyLoaded]);

  useEffect(() => {
    if (gantt) {
      gantt.showModalRemoveTaskLookahead = openModalRemoveTaskLookahead;
      gantt.showModalPDF = openModalPDF;
    }
  }, [gantt]);

  /**
   * Functions
   */

  const refreshBaselinesStates = async (shouldSaveGanttData = true) => {
    baselineSaveInProcess = true;
    //await refreshCalendars(projectState.sectorSelected, setCalendars);

    // Use baseline hook to reload data
    const { baselinePoints, baselineVersions } = await loadBaselineData(
      projectState.sectorSelected
    );

    /** filter activities added when one or more activities were deleted  */
    const newSectorResActivity = baselinePoints.filter((el) => el.activityId);

    ganttInstance &&
      newSectorResActivity.forEach((newAc) => {
        const oldRef = ganttInstance.getTask(newAc.activityDhtmlxId);
        if (oldRef instanceof Object) {
          oldRef.baseline_points = [newAc];
        }
      });

    /** remove deleted activities  */
    updateTasksDeletedRender(ganttInstance.deletedUnsavedActivitiesAux);

    await goCalculatePonderators(true);
    ganttInstance.updateExpectedGlobal &&
      ganttInstance.updateExpectedGlobal({ gantt: ganttInstance });

    setAllBaselines(baselineVersions);
    const mainBaselineCallback = () => {
      baselineSaveInProcess = false;
      if (shouldSaveGanttData) {
        saveHandler();
      }
      ganttInstance.render();

      if (window.savingBaselineOnProcess) {
        window.savingBaselineOnProcess = false;
        setIsProcessing(false);
      }
    };
    timerManager.registerAutoTimeout(
      mainBaselineCallback,
      2000,
      'baselineProcess'
    );
  };

  const requestGoSaveHandler = async () => {
    setSaveProcessActive(true);
    try {
      await goSaveHandler();
    } finally {
      setSaveProcessActive(false);
      activeSectorFlag('update_activities_work_hours', false);
    }
  };

  /** getSubs function is now handled by useSubcontracts hook */

  /** getTags function is now handled by useTags hook */

  /**
   * This functions, allow to delete duplicates objects from an array
   * @param {*} arr Array with objects to be cleaned
   * @param {*} comp Element that must be unique in our objects, as example ID
   */
  function getUnique(arr, comp) {
    // store the comparison  values in array
    const unique = arr
      .map((e) => e[comp])
      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)
      // eliminate the false indexes & return unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);
    return unique;
  }

  /**
   * This function deals with the change of multi select.
   * Deals with  deleting, and clicking news cols.
   * @param {*} value Array of values for multi select of Ant Design Framework
   */
  function handleChange(value) {
    if (!value) return;
    setSelectedOption(value);
    value = value.map((v) => v.value);
    /** This if statement allows to check if there is some fields to disable */
    if (value.length < ganttState.activatedColumns.length) {
      /** link for docs https://stackoverflow.com/questions/1187518/how-to-get-the-difference-between-two-arrays-in-javascript */
      const colsToDisable = ganttState.activatedColumns.filter(
        (x) => !value.includes(x)
      );
      colsToDisable.map((colToDisable) => {
        if (ganttInstance.getGridColumn(colToDisable)) {
          ganttInstance.getGridColumn(colToDisable).hide = true;
        }
      });
    }
    /** Then by mapping array, can active the columns indeed and render methods will take effect visually */
    dispatch(ganttActions.setActivatedColumns(value));
    value.map((columnName) => {
      if (ganttInstance.getGridColumn(columnName)) {
        ganttInstance.getGridColumn(columnName).hide = false;
      }
    });
    ganttInstance.render();
    ganttInstance.adjustGridWidth();
    const hasSlackCritical = checkSlackCritical(value);
    if (hasSlackCritical) {
      ganttInstance.autoSchedule();
    }
    updateDefaultView();
  }

  const updateWidgetAndSectorData = async () => {
    // message.loading(t('saving_alert'), 2);
    const updatedSector = await sectorService.showByLooaheadWeekly(
      projectState.sectorSelected
    );
    const currentSector = updatedSector.sector;

    /** NOTE: This code section were added to calculate widget data easely */
    try {
      if (currentSector != null || currentSector != undefined) {
        if (!ganttInstance) {
          Sentry.captureException(
            'window.to_use_react_gantt is null, cannot calculate accumulated duration'
          );
          return;
        }

        const accumulatedGanttDuration = ganttInstance
          .getTaskBy((t) => !ganttInstance.hasChild(t.id))
          .reduce((ac, t) => ac + t.duration, 0);
        currentSector.accumulatedDuration = accumulatedGanttDuration;
        await sectorService.update(currentSector);
        const copy_sector = { ...currentSector };
        copy_sector.cncs = [];
        copy_sector.constraints = [];
        copy_sector.weekcommitments = [];
        sessionStorage.setItem('currentSector', JSON.stringify(copy_sector));
      } else {
        Sentry.captureException('currentSector.accumulatedDuration null');
      }
    } catch (error) {
      Sentry.captureException(error);
    }

    /** Widget retro handler for accum for active baseline */
    const activeBaseline = baselinesFromHook.find((base) => base.active);
    if (activeBaseline) {
      const baseline = activeBaseline;
      if (!baseline.accumulatedDuration) {
        const accumDuration = baseline.points
          .filter((t) => {
            const tRef = ganttInstance.getTask(t.activityDhtmlxId);
            if (tRef) {
              if (!ganttInstance.hasChild(tRef.id)) {
                return true;
              }
            }
          })
          .reduce((ac, t) => ac + t.duration, 0);
        baseline.accumulatedDuration = accumDuration;
        sectorBaselineVersionService.update(baseline);
      }
    }
  };

  const defineModalDeleteMessage = (paragraph) => {
    let msg;
    if (paragraph === 'first') {
      msg = t('modals.gantt.non_saved_activities.deleted_text');
    } else if (paragraph === 'second') {
      msg = t('modals.gantt.non_saved_activities.deleted_text2');
    }
    return msg;
  };

  async function goSaveBaseline(
    saveBaselineModalautoParam,
    shouldSaveGanttData = true
  ) {
    if (masterplanPermissions()?.gantt === 'V') {
      message.error(t('without_permission_to_save'), 2);
      return;
    }

    /** Create a new baseline version object */
    const currentUser = getSignedUser();
    const accumulatedGanttDuration = getAccumulatedGanttDuration(ganttInstance);
    const newBaselineVersion = {
      create_date: moment().format('YYYY/MM/DD H:mm'),
      name: saveBaselineModalautoParam.name,
      description: saveBaselineModalautoParam.description,
      creatorId: currentUser.id,
      creator: currentUser,
      sectorId: sectorObject.id,
      visible: true,
      active: true,
      accumulatedDuration: accumulatedGanttDuration,
      saveOption: saveBaselineModalautoParam.toSaveOption
    };

    /** Find the last active baseline version */
    /** Set all old baselines active and visible to false */
    let lastActiveBaselineVersion;
    const asyncAllBaselines = baselinesFromHook.map(async (baselineVersion) => {
      if (baselineVersion.active) {
        lastActiveBaselineVersion = baselineVersion;
      }

      baselineVersion.active = false;
      baselineVersion.visible = false;
      await sectorBaselineVersionService.update(baselineVersion);
    });
    await Promise.all(asyncAllBaselines);

    /** Create the new baseline version, and update allbaselines state */
    const resVersion =
      await sectorBaselineVersionService.create(newBaselineVersion);
    newBaselineVersion.id = resVersion.id;
    setAllBaselines([...baselinesFromHook, newBaselineVersion]);

    /** Clone calendars to base calendars */
    const hashTable = await createBaseCalendarFromCalendar(
      resVersion,
      lastActiveBaselineVersion,
      ganttCalendars
    );

    /** Create baseline points for new baseline version */
    const bodyForNewBaselinePoints = getBodyForNewBaseline(
      hashTable,
      newBaselineVersion,
      ganttInstance,
      sectorObject
    );
    const resPoints = await sectorBaselinePointService.createAllBaselines(
      bodyForNewBaselinePoints
    );

    /** Set flag to update ponderators,executed by location reload */
    if (resPoints) {
      await refreshBaselinesStates(shouldSaveGanttData);
      notifyMessage({
        title: t('saved'),
        message: t('saved_baseline_succesfully'),
        type: 'success'
      });
      setSaveBaselineModal({ ...saveBaselineModal, visible: false });
    }

    /** Tracking event */
    const eventResult = resPoints ? 'yes' : 'no';
    const baselineType =
      baselineOptions[saveBaselineModalautoParam.toSaveOption];
    trackingEvent(
      'baseline_creation',
      {
        ...getBasicAmplitudEventProperties(),
        baseline_type: baselineType,
        event_result: eventResult
      },
      AMPLITUDE_SERVICE
    );
  }

  const goSaveHandler = async (clickSaveButton = false) => {
    let faildInformation = '';
    const newActivitiesRelationsArray = [];
    const newActivitiesArray = [];
    let tasktDeleted = [];
    const massiveHistoricalArray = [];
    try {
      await updateWidgetAndSectorData();
      const ganttInstanceForSaving = window.to_use_react_gantt;
      const loggedUser = getSignedUser();
      const currentCompany = stateCompany.currentCompany;
      const project = projectState.allProjects.find(
        (p) => p.id == projectState.projectSelected
      );

      totangoSetAccountAttributes(
        loggedUser,
        projectState.projectSelected,
        currentCompany?.name,
        currentCompany?.id,
        project?.name,
        project?.stage,
        project?.country
      );

      totangoEventTracking(
        `p_${projectState.projectSelected}`,
        loggedUser,
        'Save changes Masterplan',
        'Master Plan'
      );

      trakerServiceAppCues('Save Masterplan');

      const currentGanttData = ganttInstanceForSaving.serialize();
      const nonUpdatedTasksCounter =
        ganttInstanceForSaving &&
        ganttInstanceForSaving.checkNoUpdatedActivities &&
        ganttInstanceForSaving.checkNoUpdatedActivities();

      const nonSavedTasksCounter =
        ganttInstanceForSaving &&
        ganttInstanceForSaving.checkNoSavedActivities &&
        ganttInstanceForSaving.checkNoSavedActivities();

      const planeModifiedActivities = [
        ...nonUpdatedTasksCounter,
        ...nonSavedTasksCounter
      ];

      /** Same with links */
      const nonUpdatedLinksCounter =
        ganttInstanceForSaving &&
        ganttInstanceForSaving.checkNoUpdatedLinks &&
        ganttInstanceForSaving.checkNoUpdatedLinks();
      const nonSavedLinksCounter =
        ganttInstanceForSaving &&
        ganttInstanceForSaving.checkNoSavedLinks &&
        ganttInstanceForSaving.checkNoSavedLinks();
      const planeModifiedLinks = [
        ...nonUpdatedLinksCounter,
        ...nonSavedLinksCounter
      ];

      if (!planeModifiedActivities || !planeModifiedLinks)
        throw new Error(
          'Error with activities and links to save - scheduleGantt may not be initialized'
        );

      /** This line replaces whole data, by the only edited and created elements */
      currentGanttData.data = planeModifiedActivities.filter((act) =>
        Boolean(act)
      );
      currentGanttData.links = planeModifiedLinks.filter((link) =>
        Boolean(link)
      );

      /** Mapping Gantt Task objects we can transform each of them to ProPlanner Data Structure */
      const activities = currentGanttData.data.map((activity, index) => {
        const convertedObject = convertGanttTaskToActivity(activity);
        convertedObject.sectorId = sectorObject.id;
        convertedObject.ganttId = ganttId;
        convertedObject.has_childs = Boolean(
          ganttInstanceForSaving.hasChild(activity.id)
        );
        if (activity.proplannerId) {
          convertedObject.id = activity.proplannerId;
        }
        return convertedObject;
      });

      /** Same with Gantt Links objects */
      const activityrelations = currentGanttData.links.map(
        (activityrelation) => {
          if (!activityrelation.lag) {
            activityrelation.lag = 0;
          }
          activityrelation.sectorId = sectorObject.id;
          activityrelation.ganttId = ganttId;
          const convertedObject =
            convertLinkToActivityRelation(activityrelation);
          if (activityrelation.proplannerId) {
            convertedObject.id = activityrelation.proplannerId;
          }
          return convertedObject;
        }
      );

      /** Fetch to save current Gantt Data */
      const hashMap = {};
      activities.forEach((elem) => {
        if (!hashMap[elem.unique_id]) {
          newActivitiesArray.push(elem);
          hashMap[elem.unique_id] = true;
        }
      });

      const hashMapRelations = {};
      activityrelations.forEach((elem) => {
        if (!hashMapRelations[elem.unique_id]) {
          newActivitiesRelationsArray.push(elem);
          hashMapRelations[elem.unique_id] = true;
        }
      });

      const breadcrumbMessage = `user ${loggedUser.email} is saving sectorId ${projectState.sectorSelected}`;
      log('saving_sector', breadcrumbMessage);
      let res = await activityService.createAll(
        newActivitiesArray,
        projectState.sectorSelected
      );
      const back_up_data = window.backup_data_saving_use;
      if (res) {
        /** We update the news activities with the new id created */
        res.map((activity) => {
          if (activity.unique_id) {
            const ganttDhtmlxTask = ganttInstanceForSaving.getTask(
              activity.unique_id
            );
            ganttDhtmlxTask.proplannerId = activity.id;
            // INSANE USAGE OF MEMORY gantt.updateTask(ganttDhtmlxTask.id)

            const activity_backup = newActivitiesArray.find(
              (a) => a.unique_id == activity.unique_id
            );
            if (activity_backup) {
              activity_backup.id = activity.id;
            }
          }
        });
        await activityService.updateResponsiblesAndTags(
          newActivitiesArray,
          projectState.sectorSelected
        );

        await activityService.createAllChangeTaskDate(
          newActivitiesArray,
          projectState.sectorSelected,
          back_up_data
        );
        const currentGanttData = ganttInstanceForSaving.serialize();
        const { defaultValue, type } = activityAttributes.progress;
        const created = moment(new Date()).format('YYYY/MM/DD H:mm:ss');

        currentGanttData.data.map(({ proplannerId, progress }) => {
          const { isValid: isValidProgress } = validateActivityAttributes(
            progress,
            type
          );
          const newActivityHistorical = {
            activityId: proplannerId,
            progress: isValidProgress ? progress : defaultValue,
            created
          };

          massiveHistoricalArray.push(newActivityHistorical);
        });
        //clearStorage('activities');
      } else {
        faildInformation = 'Activities save fails';
        throw new Error('Cant save activities');
      }

      window.backup_data_saving_use = cloneDeep(
        ganttInstanceForSaving.getTaskByTime()
      );

      res = await activityRelationService.createAll(
        newActivitiesRelationsArray
      );
      if (res) {
        res.map((activityrelation) => {
          const ganttDhtmlxLink = ganttInstanceForSaving.getLink(
            activityrelation.unique_id
          );
          try {
            ganttDhtmlxLink.proplannerId = activityrelation.id;
            // INSANE USAGE OF MEMORY gantt.updateLink(ganttDhtmlxLink.id)
          } catch (e) {
            Sentry.captureException(e);
          }
        });
        //clearStorage('links');
      } else {
        faildInformation = 'Links save fails';
        throw new Error('Cant save relations');
      }

      /** Delete Stuff */
      await fetchSaveHistorical(massiveHistoricalArray);
      const updateLinkToDelete = LinksStorage.getDeletedLinks().filter(
        (link) => {
          const { id } = link;
          const isExists = ganttInstanceForSaving.isLinkExists(id);
          return !isExists;
        }
      );
      getUnique(updateLinkToDelete, 'proplannerId').map((linkToDelete) => {
        const activityrelation = convertLinkToActivityRelation(linkToDelete);
        if (linkToDelete.proplannerId) {
          activityrelation.id = linkToDelete.proplannerId;
        }
        activityRelationService.destroy(activityrelation.id);
      });

      const updateTasksToDelete = ActivitiesStorage.getDeletedActivities();

      tasktDeleted = updateTasksToDelete.map(async (activityForDelete) => {
        const activity = convertGanttTaskToActivity(activityForDelete);
        if (activityForDelete.proplannerId) {
          activity.id = activityForDelete.proplannerId;
        }
        const res = await activityService.destroy(activity.id);
        if (!res) {
          log('error_delete_activity', activity.id);
          faildInformation = 'Cant delete activities';
        }
      });

      await Promise.all(tasktDeleted);

      const tasks = ganttInstanceForSaving.getTaskByTime();
      ganttInstanceForSaving.legacy_corrected_activities = cloneDeep(tasks);

      setDeletedUnsavedActivities((prev) => []);
      setDeletedUnsavedLinks((prev) => []);
      const activitiesDeletedTaskLookahead = [];
      const activitiesRemoveIsOnLookahead = [];

      window.stackActivitiesMotherSave.forEach((activity) => {
        const currentTask = tasks.find(
          (task) => task.proplannerId === activity
        );

        if (currentTask.type === 'project') {
          activitiesDeletedTaskLookahead.push(currentTask.proplannerId);
          activitiesRemoveIsOnLookahead.push(currentTask);
        }
      });

      if (activitiesDeletedTaskLookahead.length > 0) {
        await activityService.deleteTaskByActivityId(
          activitiesDeletedTaskLookahead
        );
      }

      if (activitiesRemoveIsOnLookahead.length > 0) {
        for (const currentActivity of activitiesRemoveIsOnLookahead) {
          const current = {
            ...convertGanttTaskToActivity(currentActivity),
            id: currentActivity.proplannerId,
            has_childs: Boolean(
              ganttInstanceForSaving.hasChild(currentActivity.id)
            ),
            isOnLookahead: false
          };

          addBreadcrumbUtil(
            'goSaveHandler',
            'activitiesRemoveIsOnLookahead',
            'Attempting to update activity',
            'info',
            {
              activityId: current.id
            }
          );

          await activityService.update(current);
        }
      }
      const renderCallback = () => {
        ganttInstanceForSaving.initNonSavedTasksCounter =
          ganttInstanceForSaving.checkNoSavedActivities().length;
        ganttInstanceForSaving.initNonSavedDeletedTasksCounter =
          ActivitiesStorage.getDeletedActivities().length;
        ganttInstanceForSaving.initNonUpdatedTasksCounter =
          ganttInstanceForSaving.checkNoUpdatedActivities().length;
        ganttInstanceForSaving.initNonSavedLinksCounter =
          ganttInstanceForSaving.checkNoSavedLinks().length;
        ganttInstanceForSaving.initNonSavedDeletedLinksCounter =
          ganttInstanceForSaving.deletedUnsavedLinks.length;
        ganttInstanceForSaving.initNonUpdatedLinksCounter =
          ganttInstanceForSaving.checkNoUpdatedLinks().length;
      };
      timerManager.registerAutoTimeout(renderCallback, 500, 'render');
      updateSubmittalsHelper(currentCompany, currentProject, currentSector);

      if (!window.savingBaselineOnProcess) {
        message.success(t('saved_succesfully'), 4);
      }

      window.isShineButtonGoToLookahead = true;

      if (clickSaveButton) {
        trackingEvent(
          'saving_schedule_changes',
          {
            ...getBasicAmplitudEventProperties(),
            event_source: 'save_button_selection',
            event_result: 'Successfull',
            error_information: faildInformation
          },
          AMPLITUDE_SERVICE
        );
      }
      tasksToDelete.current = [];
      linksToDelete.current = [];
      // MOVED: ActivitiesStorage.reset() and LinksStorage.reset() moved to finally block
    } catch (error) {
      setShowBackUpModal(true);
      message.error(
        t('lang') === 'es'
          ? 'No hemos podido guardar la informacion.'
          : 'We were unable to save the information.'
      );

      trackingEvent(
        'save_schedule_failed_dev',
        {
          ...getBasicAmplitudEventProperties(),
          error_information: faildInformation
        },
        AMPLITUDE_SERVICE
      );
      trackingEvent(
        'saving_schedule_changes',
        {
          ...getBasicAmplitudEventProperties(),
          event_source: 'save_button_selection',
          event_result: 'Failed',
          error_information: faildInformation
        },
        AMPLITUDE_SERVICE
      );
      Sentry.withScope((scope) => {
        scope.setTags({
          ganttChartView: 'goSaveHandler'
        });
        Sentry.captureException(error);
      });

      const deleteActivitiesBackup = tasksToDelete.current.map((t) => ({
        id: t.proplannerId
      }));
      const linksDeleteBackup = linksToDelete.current.map((l) => ({
        id: l.proplannerId
      }));
      activityService.createAllBackUp(
        newActivitiesArray,
        projectState.sectorSelected,
        newActivitiesRelationsArray,
        deleteActivitiesBackup,
        linksDeleteBackup
      );
    } finally {
      setSaveProcessActive(false);
      setIsProcessing(false);
      await sectorService.invalidateCache(projectState.sectorSelected);
      // CRITICAL FIX: Reset storage AFTER all operations are complete
      ActivitiesStorage.reinit();
      LinksStorage.reinit();
    }
  };

  /**
   * this function updates the gantt eliminating the deleted tasks that are displayed after saving the baseline
   */
  const updateTasksDeletedRender = async (deletedUnsavedActivities) => {
    if (ActivitiesStorage.getDeletedActivities()) {
      ActivitiesStorage.getDeletedActivities().map((el) => {
        const getTaskDeleted = gantt.getTask(el.id);
        if (getTaskDeleted && gantt.isTaskExists(getTaskDeleted.id)) {
          gantt.deleteTask(getTaskDeleted.id);
        }
      });
    }
  };

  const saveBaseLineWhenDeletedActivities = async () => {
    const shouldSaveGanttData = false;
    const sectorResActivitybaseVersion =
      await sectorService.showActivityVersions(projectState.sectorSelected);
    const { baselines } = sectorResActivitybaseVersion;
    const newBaseline = baselines.filter((b) => b.active === true);

    const deletedUnsavedActivitiesIds = new Set(
      ActivitiesStorage.getDeletedActivities().map((activity) => activity.id)
    );
    if (newBaseline.length > 0) {
      const saveBaselineDeletedActivides = {
        ...saveBaselineModal,
        name: `${newBaseline[0].name} - ${t('master_plan.updated')} `,
        description: `${t('master_plan.updated')}: ${deletedUnsavedActivitiesIds.size} ${t('master_plan.activities_deleted')}`,
        toSaveOption: 4
      };
      message.info(
        t('lang') === 'es' ? 'Guardando línea base' : 'Saving baseline',
        2
      );
      await goSaveBaseline(saveBaselineDeletedActivides, shouldSaveGanttData);
      deletedUnsavedActivitiesIds.clear();
    } else {
      openNotificationBaseline();
      trackingEvent(
        'no_baseline_active_dev',
        {
          ...getBasicAmplitudEventProperties(),
          event_source: 'save_button_selection'
        },
        AMPLITUDE_SERVICE
      );
    }
  };

  const openNotificationBaseline = () => {
    notification.config({
      duration: 6
    });
    notification.error({
      message:
        t('lang') === 'es' ? 'Activar línea de base ' : 'Activate Baseline ',
      description:
        t('lang') === 'es'
          ? 'El programa no tiene una línea base activa. Verifica la configuración para un seguimiento adecuado'
          : 'The program does not have an active baseline. Verify the settings for proper follow-up.',
      style: { zIndex: 999999 },
      key: 'base'
    });
  };

  /** This function handle saving data (links and activities) */
  async function saveHandler(clickSaveButton = false) {
    if (masterplanPermissions()?.gantt === 'V') {
      message.error(t('without_permission_to_save'), 2);
      return;
    }

    if (saveProcessActive) {
      message.open({
        type: 'loading',
        content:
          t('lang') === 'es'
            ? 'Hay un guardado en proceso.'
            : 'There is a save in process.',
        duration: 2
      });
      return;
    }
    setSaveProcessActive(true);
    try {
      /** get versions */
      const sectorResActivitybaseVersion =
        await sectorService.showActivityVersions(projectState.sectorSelected);
      if (
        ActivitiesStorage.getDeletedActivities().length &&
        !modalMetadataDelete.isRunning &&
        sectorResActivitybaseVersion.baselines.length
      ) {
        if (showModalWhenDeleteActivies) {
          if (
            ActivitiesStorage.getDeletedActivities().length &&
            !modalMetadataDelete.isRunning &&
            sectorResActivitybaseVersion.baselines.length
          ) {
            modalMetadataDelete.title = ' &nbsp;';
            modalMetadataDelete.isRunning = true;
            modalMetadataDelete.okText = t('modals.gantt.new_baseline.save');
            modalMetadataDelete.cancelText = t(
              'modals.gantt.non_saved_activities.cancel'
            );
            modalMetadataDelete.content = (
              <div>
                <div className="icon-center">
                  <WarningIcon color={colors.brandOrange40} />
                </div>
                <div className="delete-text-gantt">
                  <div>{defineModalDeleteMessage('first')}</div>
                  <div>{defineModalDeleteMessage('second')}</div>
                </div>
              </div>
            );
            modalMetadataDelete.visible = true;
            modalMetadataDelete.onOkPayload = async (
              saveBaselineModalAutoParam
            ) => {
              await goSaveHandler(clickSaveButton);
              await goSaveBaseline(saveBaselineModalAutoParam);
              setSaveProcessActive(false);
            };
            modalMetadataDelete.onCancelPayload = () => {
              setSaveProcessActive(false);
            };
            updateModalRenderDelete();
          }
        } else {
          if (
            atLeastOneActivityHasBaseline(
              ActivitiesStorage.getDeletedActivities()
            )
          ) {
            await saveBaseLineWhenDeletedActivities();
          }
          await goSaveHandler(clickSaveButton);
        }
      } else {
        await goSaveHandler(clickSaveButton);
      }
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      setSaveProcessActive(false);
      setIsProcessing(false);
    }

    return false;
  }

  function atLeastOneActivityHasBaseline(activities) {
    return activities.some((activity) => activity.baselineObject);
  }

  const fetchSaveHistorical = async (historicals) => {
    const res =
      await historicalActivityProgressService.massiveCreate(historicals);
  };

  function updateModalRender() {
    setModalMetadata((prev) => {
      prev = cloneDeep(modalMetadata);
      return prev;
    });
  }

  function updateModalRenderDelete() {
    setModalMetadataDelete((prev) => {
      prev = cloneDeep(modalMetadataDelete);
      return prev;
    });
  }

  /** This effect handle loosing focus when modals are open */
  useEffect(() => {
    if (
      (saveScheduleUpdatesModal.visible ||
        allScheduleUpdatesModal.visible ||
        saveBaselineModal.visible ||
        allBaselinesModal.visible) &&
      gantt
    ) {
      gantt.disconnectKeyboardNavigation = true;
    } else if (gantt) {
      gantt.disconnectKeyboardNavigation = false;
    }
  }, [
    saveBaselineModal,
    allBaselinesModal,
    allScheduleUpdatesModal,
    saveScheduleUpdatesModal,
    allScheduleUpdatesModal
  ]);

  /**
   * This function calcualtes whole gantt ponderators
   * @param {*} avoidSave Flag to avoid saving changes
   */
  const goCalculatePonderators = async (avoidSave = false) => {
    const allActivities = ganttInstance.getTaskByTime();
    allActivities.forEach((ac) => {
      ac.ponderator = 0;
    });

    const withChildsTasks = allActivities.filter((ac) => {
      if (ganttInstance.hasChild(ac.id)) {
        return true;
      }
    });

    const getFirstChildTask = (parent, ganttInstance) => {
      const childIds = ganttInstance.getChildren(parent.id);
      if (!childIds || childIds.length === 0) return null;
      return ganttInstance.getTask(childIds[0]);
    };

    for (const parent of withChildsTasks) {
      calculatePonderators(parent, ganttInstance, projectState);
      const firstChild = getFirstChildTask(parent, ganttInstance);
      if (firstChild) {
        await check_progress(ganttInstance, firstChild);
      }
    }

    ganttInstance.render();
    if (!avoidSave) {
      saveHandler();
    }
  };

  const updateScheduleUpdates = async () => {
    await fetchScheduleUpdates(projectState.sectorSelected);

    const updateCallback = () => {
      saveHandler();
    };
    timerManager.registerAutoTimeout(updateCallback, 2000, 'updateSchedule');
  };

  const handleConfigClick = (opt) => {
    switch (opt) {
      case 'view_calendars':
        props.history.push('calendars');
        break;
      case 'save_baseline':
        setSaveBaselineModal({
          ...saveBaselineModal,
          visible: true,
          title: t('modals.gantt.all_baselines.newbase_label')
        });
        break;
      case 'base_lines':
        setAllBaselinesModal({
          ...allBaselinesModal,
          visible: true,
          title: t('baselines')
        });
        break;
      case 'show_schedule_updates':
        setAllScheduleUpdatesModal({
          ...allScheduleUpdatesModal,
          visible: true,
          title: t('modals.gantt.schedule_updates.schedule_updates')
        });
        break;
      case 'save_schedule_updates':
        setSaveScheduleUpdatesModal({
          ...saveScheduleUpdatesModal,
          visible: true,
          title: t('modals.gantt.schedule_updates.new_schedule_update')
        });
        break;
      case 'update_schedule_updates':
        setSaveScheduleUpdatesModal({
          ...saveScheduleUpdatesModal,
          visible: false,
          comment: '',
          update_name: ''
        });
        updateScheduleUpdates();
        break;
    }
  };

  /**
   * This function returns the baseline, workhour, activity modification, adding subs/tags modals
   * @returns A div with all components modal elements
   */
  const renderViewModals = (saveHandler) => (
    <div>
      <ScheduleModal
        handleConfigClick={handleConfigClick}
        allScheduleUpdatesModal={allScheduleUpdatesModal}
        setAllScheduleUpdatesModal={setAllScheduleUpdatesModal}
        allScheduleUpdates={allScheduleUpdates}
        saveScheduleUpdatesModal={saveScheduleUpdatesModal}
        setSaveScheduleUpdatesModal={setSaveScheduleUpdatesModal}
        colors={colors}
        modalStyles={modalStyles}
        sector={sectorObject}
        gantt={ganttInstance}
        t={t}
      />
      <BaselineModal
        saveHandler={saveHandler}
        setIsProcessing={setIsProcessing}
        refreshBaselinesStates={refreshBaselinesStates}
        deletedUnsavedActivities={deletedUnsavedActivities}
        handleConfigClick={handleConfigClick}
        calendars={ganttCalendars}
        sector={sectorObject}
        allBaselinesModal={allBaselinesModal}
        setAllBaselinesModal={setAllBaselinesModal}
        colors={colors}
        updateModalRender={updateModalRender}
        updateModalRenderDelete={updateModalRenderDelete}
        modalMetadataDelete={modalMetadataDelete}
        modalMetadata={modalMetadata}
        t={t}
        setAllBaselines={setAllBaselines}
        allBaselines={baselinesFromHook}
        setSaveBaselineModal={setSaveBaselineModal}
        saveBaselineModal={saveBaselineModal}
        setSaveBaselineModalAuto={setSaveBaselineModalAuto}
        saveBaselineModalAuto={saveBaselineModalAuto}
        permission={masterplanPermissions().gantt}
        modalStyles={modalStyles}
      />
      <ActivityModification
        updateModalRender={updateModalRender}
        permission={masterplanPermissions().gantt}
        saveHandler={saveHandler}
        t={t}
        activityModificationSelected={activityModificationSelected}
      />
      <ModalAddSubContract
        t={t}
        Visible={visibleFormSubcontract}
        setVisible={() => dispatch(hideSubcontractModal())}
      />
      <ModalAddTags
        t={t}
        Visible={visibleFormTags}
        setVisible={() => dispatch(hideTagsModal())}
        module="schedule"
      />
      <ConstraintValidationModal isVisible={false} t={t} />
    </div>
  );

  const dataForFilterColumns = {
    className: 'filter-lookahead-multi-check',
    placeholder: t('master_plan.search'),
    value: selectedOption,
    onChange: handleChange,
    options: null,
    getDropdownButtonLabel: (_) => null
  };

  const getHeightGant = () => {
    const isBABOpen = Boolean(selectedActivities?.length);
    const isActivityCardOpen =
      drawer.status === 'OPEN' && drawer.origin === 'bottom';
    let heightGantt = 'calc(100vh - 215px)';
    if (isBABOpen && isActivityCardOpen) {
      heightGantt = 'calc(100vh - 527px)';
    } else if (isBABOpen) {
      heightGantt = 'calc(100vh - 214px)';
    } else if (isActivityCardOpen) {
      heightGantt = 'calc(100vh - 527px)';
    }

    if (!isFirstView && (!isBABOpen || isActivityCardOpen)) {
      const drawerNode = document.querySelector('[data-testid=drawer_root]');

      if (drawerNode) {
        drawerNode.addEventListener(
          'webkitTransitionEnd',
          (event) => {
            if (event.propertyName !== 'transform') return;

            drawerNode.removeEventListener('webkitTransitionEnd', () => {
              window.to_use_react_gantt.render();
            });
          },
          false
        );
      }
    }

    setIsFirstView(false);

    return heightGantt;
  };

  /**
   * This function check if the view is totally loaded if dont, it returns an loader to preload data
   * @returns If loading initial gantt data, a loader, if it's done, the filter header and gantt
   */
  function renderLoadedContent() {
    const isGanttChart = isLegacyGanttUrl(window.location.pathname) || isNewGanttUrl(window.location.pathname);
    return (
      <Col style={{ display: isGanttChart ? 'block' : 'none' }}>
        <GanttFilterHeader
          t={t}
          handleConfigClick={handleConfigClick}
          saveHandler={saveHandler}
          calendars={ganttCalendars}
          sectorSelected={sectorObject}
          goUpload={() => props.history.push('/importgantt')}
          dataForColumns={dataForFilterColumns}
          modalDelMass={modalDelMass}
          modalDupMass={modalDupMass}
          modalDupMassAddActivities={modalDupMassAddActivities}
          callbackModalDupConfirmMass={callbackModalDupConfirmMass}
          ganttInstance={ganttInstance}
        />
      </Col>
    );
  }
  const contentChildren = () => (
    <div className="delete-stage__content">
      <div className="content__form">
        <div className="form__icon">
          <WarningIcon color="#ED8536" />
        </div>
        <div className="form__title">
          <h5>{t('not_save_mp_error.text_1')}</h5>
        </div>
        <div className="form__input">
          <label style={{ textAlign: 'center' }}>
            {t('not_save_mp_error.text_2')}
          </label>
        </div>
      </div>
      <div className="content__buttons">
        {/* <button className='buttons__cancel' onClick={() => handleCloseModal()}>{t('delete_stage.button_cancel_text')}</button> */}
        <button className="buttons__delete" onClick={() => XMLBackupAcepted()}>
          {t('not_save_mp_error.button')}
        </button>
      </div>
    </div>
  );

  const XMLBackupAcepted = () => {
    setShowBackUpModal(false);
    window.to_use_react_gantt.recoveryErrorSaveProcessXml();
  };

  const openModalRemoveTaskLookahead = (
    t,
    task,
    parent,
    parentProplannerId
  ) => {
    setIsShowModalRemoveTaskLookahead(true);
    setDataModalRemoveTaskLookahead({
      t,
      task,
      parent,
      parentProplannerId
    });
  };
  const openModalPDF = () => {
    setIsShowModalPDF(true);
  };

  /**
   * Render
   */

  if (!scheduleGanttFullyLoaded) {
    return null;
  }

  return (
    <Row>
      {renderLoadedContent()}
      {renderViewModals(saveHandler)}
      <ModalRemoveTaskLookahead
        isShow={isShowModalRemoveTaskLookahead}
        setIsShow={setIsShowModalRemoveTaskLookahead}
        {...dataModalRemoveTaskLookahead}
      />
      <ModalMessage
        t={t}
        isShow={isShowModalPDF}
        setIsShow={setIsShowModalPDF}
      />
      {ModalSystem({
        closable: false,
        visible: showBackUpModal,
        theme: 'dark',
        setVisible: setShowBackUpModal,
        showTitle: false,
        centered: true,
        width: 520,
        children: contentChildren()
      })}
    </Row>
  );
}

const mapStateToProps = (state) => ({
  selectedActivities: getSelectedActivitiesSelector(state),
  drawer: getDrawerSelector(state),
  isGanttLoading: getGanttLoadingSelector(state)
});

export const unsavedChangesListener = function (event) {
  const gantt = window.to_use_react_gantt;
  const { haveChanges } = checkForChanges(gantt);

  const user = getSignedUser();
  if (!user || !user.id) return;

  trackingEvent(
    'unsaved_changes_alert_triggered',
    {
      ...getBasicAmplitudEventProperties(),
      haveChanges: haveChanges
    },
    AMPLITUDE_SERVICE
  );

  if (haveChanges) {
    const confirmationMessage =
      'Tienes cambios sin guardar. ¿Seguro que quieres salir?';

    event.returnValue = confirmationMessage;
    return confirmationMessage;
  }
};

export default connect(mapStateToProps, {})(withTranslation()(GanttChartView));
